/**
 * How a settlement with loyalty points treats an amount that is not a whole
 * number of points (`Tenant.loyaltyPointRounding`, owner decision on #459).
 *
 * - WHOLE: refused; the amount must be a whole number of points.
 * - DOWN: the whole points the amount covers are spent, the settlement
 *   records their value and the rest stays due.
 * - UP: the points rounded up are spent and the settlement records the
 *   amount asked; the client gives up the surplus value.
 */
export const LOYALTY_POINT_ROUNDING_MODES = ["WHOLE", "DOWN", "UP"];
/** The rounding a tenant applies when it has not chosen one. */
export const DEFAULT_LOYALTY_POINT_ROUNDING = "DOWN";
/** French label of each mode, as the settings screen shows it. */
export const LOYALTY_POINT_ROUNDING_LABELS = {
    WHOLE: "Nombre entier de points uniquement",
    DOWN: "Arrondi au point inférieur",
    UP: "Arrondi au point supérieur",
};
export function isLoyaltyPointRounding(value) {
    return LOYALTY_POINT_ROUNDING_MODES.includes(value);
}
//# sourceMappingURL=loyalty-point-rounding.js.map